<template>
  <div @load="loading">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>
    <div class="gameplay_game_box_list gameplay_tap_box att6" >


        <div class="gameplay_btns_row" v-for="(row, rowindex) in twoDimensionalTable" :key="rowindex">
          <div :disabled="buttonPushed" type="" class="knot_box" v-for="(col, colindex) in row"
                  :key="rowindex-colindex" :style="disableDiv"
                  @click.prevent="sendAnswer(rowindex, colindex)"
                  :ref="rowindex === 0 ? (colindex + 1) : (rowindex * numOfCols) + (colindex + 1)">
            <img :src=col>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';


export default {
  name: 'attentionEmoji',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      matrixImages: {
        SET1a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_01_a.png',
        },
        SET1b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_01_b.png',
        },
        SET2a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_02_a.png',
        },
        SET2b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_02_b.png',
        },
        SET3a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_03_a.png',
        },
        SET3b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_03_b.png',
        },
        SET4a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_04_a.png',
        },
        SET4b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_04_b.png',
        },
        SET5a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_05_a.png',
        },
        SET5b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_05_b.png',
        },
        SET6a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_06_a.png',
        },
        SET6b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_06_b.png',
        },
        SET7a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_07_a.png',
        },
        SET7b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_07_b.png',
        },
        SET8a: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_08_a.png',
        },
        SET8b: {
          images: 'static/images/game_images/attention_07/ΑΤΤ_07_08_b.png',
        },
      },
      gameInfo: null, // NEW
      twoDimensionalTable: [], // NEW
      numOfRow: 0,
      numOfCols: 0,
      buttonPushed: false,
    };
  },
  mounted() {
    this.$nextTick(() => { this.loading(); });
  },
  created() {
    this.initGameData();
  },
  methods: {
    loading() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.createMatrix();
    },
    createMatrix() {
      this.numOfRow = this.gameInfo.length / 2;
      this.numOfCols = this.gameInfo.length / 2;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill(this.matrixImages[this.gameInfo.emojiEnum].images));
      let indexOfCorrectAnswer = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          if (indexOfCorrectAnswer === this.gameInfo.correctIndex) this.twoDimensionalTable[i][j] = this.matrixImages[this.gameInfo.emojiEnum2].images;
          indexOfCorrectAnswer += 1;
        }
      }
    },
    sendAnswer(answerRow, answerCol) {
      const answersIndex = answerRow === 0 ? answerCol + 1 : (answerRow * this.numOfCols) + answerCol + 1;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        let isCorrectAnswer = false;
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${answersIndex - 1}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.$refs[answersIndex][0].classList.add('gameplay_btn_false');
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.$refs[answersIndex][0].classList.add('gameplay_btn_correct');
            } else {
              // something bad happened
            }
          }
          setTimeout(() => {
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
            this.$refs[answersIndex][0].classList.remove('gameplay_btn_false');
            this.$refs[answersIndex][0].classList.remove('gameplay_btn_correct');
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    disableDiv() {
      return !this.buttonPushed ? 'cursor:pointer' : 'pointer-events:none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionEmoji.vue